import type { MarketingPageContent } from './types';

export const FOR_CREATORS_CONTENT: MarketingPageContent = {
  title: 'Induce for Creators',
  headerLabel: 'For Creators',
  lede:
    'Induce is the AI media infrastructure for the next generation of content creation. For indie filmmakers and solo creators shooting out of their own kit.',
  sections: [
    {
      id: 'creator-tier',
      title: 'Creator tier',
      body: 'For indie filmmakers and solo creators shooting out of their own kit. Script-first editor, shot overrides, community continuity models, and early access to new AI features.',
    },
    {
      id: 'continuity',
      title: 'Persistent continuity',
      body: 'Your protagonist looks like your protagonist in every scene. Characters, wardrobe, locations, and mood persist across the entire timeline.',
    },
    {
      id: 'ownership',
      title: 'You own your content',
      body: 'You do. Full commercial licensing on every tier. Generated frames, cuts, and the underlying continuity model for your project stay yours - no training rights, no hidden carveouts.',
    },
  ],
};
